import React from 'react';
import { Shield, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--niko-teal)] text-sm font-medium mb-4">
            Trusted by Healthcare Leaders
          </span>
          <h2 className="heading-2 mb-6">
            Transforming{' '}
            <span className="text-[var(--niko-teal)]">Patient Safety</span>
          </h2>
          <p className="body-large">
            Healthcare organizations across acute care and long-term care settings 
            are seeing real results with NikoSafe Connect.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="relative bg-white rounded-2xl border border-[var(--border-light)] p-8 hover:shadow-xl transition-all group"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[var(--niko-teal)] to-[var(--niko-green)] flex items-center justify-center">
                  <Quote className="w-4 h-4 text-white" />
                </div>
              </div>

              {/* Quote */}
              <blockquote className="text-[var(--text-body)] leading-relaxed mb-6 pt-4">
                "{testimonial.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[var(--niko-teal)]/20 to-[var(--niko-green)]/20 flex items-center justify-center">
                  <span className="text-lg font-semibold text-[var(--niko-teal)]">
                    {testimonial.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-[var(--text-primary)]">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-[var(--text-secondary)]">
                    {testimonial.role}
                  </p>
                  <p className="text-xs text-[var(--text-muted)]">
                    {testimonial.facility}
                  </p>
                </div>
              </div>

              {/* Decorative */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-br from-[var(--niko-teal)]/5 to-[var(--niko-green)]/5 rounded-tl-[100px] rounded-br-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>

        {/* Founder Note */}
        <div className="mt-16 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-[var(--niko-teal)]/5 to-[var(--niko-green)]/5 rounded-3xl" />
          <div className="relative p-8 lg:p-12 text-center">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[var(--niko-teal)] to-[var(--niko-green)] flex items-center justify-center mx-auto mb-6">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h3 className="heading-3 mb-4">
              Built by Someone Who's Been There
            </h3>
            <p className="body-large max-w-3xl mx-auto">
              NikoSafe Connect was created by a registered nurse, infection preventionist, 
              quality director, and patient safety leader with years of experience across 
              acute care and long-term care. Every feature is designed from the reality 
              of accreditation surveys, incident reports, outbreak management, and the 
              daily pressure of keeping patients safe.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
